//交易订单列表
export const tradState = {
  searchPlaceholder: '商户订单号/交易订单号',
  tableHead: [{
      prop: 'createTime',
      label: '交易时间',
      width: '170'
    },
    {
      prop: 'outTradeNo',
      label: '商户订单号',
    },
    {
      prop: 'dealTradeNo',
      label: '交易订单号',
      width: '160'
    },
    {
      prop: 'tradeType',
      label: '支付类型',
    },
    {
      prop: 'tradeChannel',
      label: '支付渠道',
    },
    {
      prop: 'status',
      label: '支付状态',
    },
    {
      prop: 'orderAmount',
      label: '订单金额(元)',
    },
    {
      prop: '',
      label: '操作',
    },
  ],
  tradTime: [{
      label: '支付时间',
      value: 1,
    },
    {
      label: '交易时间',
      value: 2,
    },
  ],
  query_form_list: [{
    label: '支付状态',
    prop: 'payStatus',
    options: [{
        key: '全部状态',
        value: 0,
      },
      {
        key: '待支付',
        value: 1,
      },
      {
        key: '已支付',
        value: 3,
      },
      {
        key: '已支付(含退款)',
        value: 8,
      },
      // {
      //   key: '已取消',
      //   value: '', //后端说没有这个状态
      // },
    ],
  }],
  rightList: ['支付金额：', '支付订单数：', '导出支付记录：']
};
//退款订单列表
export const refundState = {
  searchPlaceholder: '交易订单号/退款订单号',
  tableHead: [{
      prop: 'createTime',
      label: '交易时间',
      width: '170'
    },
    {
      prop: 'refundNo',
      label: '退款订单号',
      width: '160'
    },
    {
      prop: 'dealTradeNo',
      label: '交易订单号',
      width: '160'
    },
    {
      prop: 'tradeType',
      label: '支付类型',
    },
    {
      prop: 'tradeChannel',
      label: '支付渠道',
    },
    {
      prop: 'status',
      label: '支付状态',
    },
    {
      prop: 'refundAmount',
      label: '退款金额(元)',
    },
    {
      prop: '',
      label: '操作',
    },
  ],
  tradTime: [{
      label: '提交时间',
      value: 1,
    },
    {
      label: '完成时间',
      value: 2,
    },
  ],
  query_form_list: [{
    label: '退款状态',
    prop: 'payStatus',
    options: [{
        key: '全部状态',
        value: 9,
      },
      {
        key: '退款中',
        value: 5,
      },
      {
        key: '退款完成',
        value: 6,
      },
      {
        key: '退款失败',
        value: 7,
      }
    ],
  }, ],
  rightList: ['退款金额：', '退款订单数：', '导出退款记录：']
}
// 详情所需数据
export const detail = {
  detailTable: new Map([
    [
      'trading/list/detail',
      [{
          title: '',
          tableHeader: [{
              prop: 'outTradeNo',
              label: '商户订单号',
            },
            {
              prop: 'dealTradeNo',
              label: '交易订单号',
            },
            {
              prop: 'tradeNo',
              label: '渠道支付流水号',
            },
            {
              prop: 'createTime',
              label: '交易时间',
            },
            {
              prop: 'payTime',
              label: '支付时间',
            },
            {
              prop: 'tradeChannel',
              label: '支付渠道',
            },
          ],
        },
        {
          title: '',
          tableHeader: [{
              prop: 'status',
              label: '交易状态',
            },
            {
              prop: 'orderAmount',
              label: '订单金额(元)',
            },
            {
              prop: 'dealAmount',
              label: '支付金额(元)',
            },
          ],
        },
      ],
    ],
    [
      'trading/refund/detail',
      [{
          title: '',
          tableHeader: [{
              prop: 'refundNo',
              label: '退款订单号',
            },
            {
              prop: 'outRefundNo',
              label: '商户退款单号',
            },
            // {
            //   prop: 'tradeNo',
            //   label: '渠道退款流水号',
            // },
            {
              prop: 'dealTradeNo',
              label: '交易订单号',
            },
            {
              prop: 'outTradeNo',
              label: '商户订单号',
            },
            {
              prop: 'tradeNo',
              label: '渠道支付流水号',
            },
          ],
        },
        {
          title: '',
          tableHeader: [{
              prop: 'orderAmount',
              label: '订单金额(元)',
            },
            // {
            //   prop: 'refundAmount',
            //   label: '申请退款金额(元)',
            // },
            // {
            //   prop: 'refundAmount',
            //   label: '应结订单金额(元)',
            // },
            {
              prop: 'refundAmount',
              label: '退款金额(元)',
            },
            {
              prop: 'dealAmount',
              label: '用户支付金额(元)',
            },
            // {
            //   prop: 'dealAmount',
            //   label: '退还用户金额(元)',
            // },
          ],
        },
        {
          title: '',
          tableHeader: [{
              prop: 'tradeChannel',
              label: '用户支付渠道',
            },
            {
              prop: 'refundWay',
              label: '退款方式',
            },
          ],
        },
        {
          title: '',
          tableHeader: [{
              prop: 'updateTime',
              label: '退款提交时间',
            },
            {
              prop: 'status',
              label: '退款状态',
            },
            {
              prop: 'refundTime',
              label: '退款完成时间',
            },
          ],
        },
      ],
    ],
  ]),

  title: new Map([
    ['trading/list/detail', '交易订单详情'],
    ['trading/refund/detail', '退款订单详情'],
  ]),
};
//支付渠道
export const channelList = new Map([
  ['WECHAT', '微信'],
  ['ALIPAY', '支付宝'],
  ['UNIONPAY', '银联'],
  ['HEEPAY', '汇付宝'],
  ['UNKNOWN', '聚合支付'],
]);
//支付状态
export const typeList = new Map([
  [1, '待支付'],
  [2, '支付中'],
  [3, '已支付'],
  [4, '支付失败'],
  [5, '退款中'],
  [6, '已退款'],
  [7, '退款失败'],
  [8, '已支付(含退款)'],
]);